import styled from "styled-components";
import { Dropdown } from "react-bootstrap";

const DropdownWrapper = styled(Dropdown)`
    width: 100%;
`;

export default DropdownWrapper;